export const CARDS_DATA: {
  id: number;
  title: string;
  description: string;
  buttonCaption?: string;
  buttonAction?: string;
}[] = [
  {
    id: 1,
    title: 'How to earn Solar Cash',
    description:
      'All participants of&nbsp;the &#34;Solar Cash&#34; program earn bonuses for stay bookings made on&nbsp;the Solartrip website or&nbsp;mobile app.',
  },
  {
    id: 2,
    title: 'How to pay with Solar Cash',
    description:
      'Solar Cash bonuses can be&nbsp;used to&nbsp;pay for all types of&nbsp;stays on&nbsp;the Solartrip website and mobile app.',
  },
  {
    id: 3,
    title: 'Does Solar Cash expire',
    description:
      'Solar Cash bonuses are valid for 12&nbsp;months from the date of&nbsp;the last accrual.',
  },
  {
    id: 4,
    title: 'Get more information<br/>and answers on Solar Cash',
    description: '',
    buttonCaption: 'Read the PDF',
    buttonAction: 'https://static.solartrip.com/docs/solar_cash_program_terms_and_conditions.pdf',
  },
];
